/* eslint-disable eag/match-named-export */

export const OVERFLOW_CLASSES: Record<'auto' | 'hidden' | 'scroll' | 'visible', string> = {
  auto: 'overflow-auto',
  hidden: 'overflow-hidden',
  scroll: 'overflow-scroll',
  visible: 'overflow-visible',
};

export const OVERFLOW_X_CLASSES: Record<'auto' | 'hidden' | 'scroll' | 'visible', string> = {
  auto: 'overflow-x-auto',
  hidden: 'overflow-x-hidden',
  scroll: 'overflow-x-scroll',
  visible: 'overflow-x-visible',
};

export const OVERFLOW_Y_CLASSES: Record<'auto' | 'hidden' | 'scroll' | 'visible', string> = {
  auto: 'overflow-y-auto',
  hidden: 'overflow-y-hidden',
  scroll: 'overflow-y-scroll',
  visible: 'overflow-y-visible',
};
